module.exports = __webpack_public_path__ + "img/42.263760b2.jpg";